export default function FaqData() {
  return {
    products: [
      {
        productIconPath: "calendar",
        displayName: "TERM LIFE INSURANCE",
        productType: "term",
        productLink: "/landing/term-insurance",
      },
      {
        productIconPath: "home",
        displayName: "LOAN PROTECTION",
        productType: "americo",
        productLink: "/landing/loan-protection",
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/BusinessSolutions/ProductData.js